import _ from 'lodash';
import config from 'client/shared/config';
import { toast } from 'react-toastify';

import {
	observable,
	action,
	computed,
	runInAction
} from 'mobx';

import BaseStore from './base-store';
import Genre from './genre';

const { routes } = config;

class GenreStore extends BaseStore {
	apiRoute = config.getRoute('genres');

	/**
	 * Observables & Computeds
	 */

	@observable
	_searchResults = [];

	@computed
	get searchResults () {
		return this._searchResults;
	}

	set searchResults (searchResults) {
		this._searchResults = searchResults;
	}

	@computed
	get genres () {
		return this._items;
	}

	set genres (genres) {
		this._items = genres;
	}

	@computed
	get options () {
		return this.searchResults
			.map((genre) => _.omit(genre, 'createdAt', 'updatedAt'));
	}

	@computed
	get sortedGenreList () {
		return _(this.genres).sortBy('label').value();
	}

	/**
	 * Action
	 */

	@action
	async saveGenre (genre, opts = {}) {
		this.isLoading = opts.silent !== true;

		try {

			const route = _.isEmpty(genre.id) ? routes.genreCreate : this.apiRoute;
			await this.save(genre, { route });
			toast.success('Genre saved!');
		} catch (err) {

			toast.error('Error saving genre!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async saveGenreArtwork (genre, opts = {}) {
		const {
			silent = false,
			onSuccess = () => {}
		} = opts;

		const payload = {
			...genre.serialized,
			path: `genre-images/${genre.id}`
		};

		this.isLoading = silent !== true;

		try {

			await this.save(payload);
			toast.success('Genre saved!');
			onSuccess(genre);
		} catch (err) {

			toast.error('Error saving genre!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async addGenres (genres) {
		this.isLoading = true;

		try {
			const data = await this.save(genres);

			runInAction('Save Genre Artwork', () => {
				this.genres = data.map((genre) => new Genre(this, genre));
			});
		} catch (error) {

			toast.error('Error saving genre!');
			throw error;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	async search (search) {
		try {

			const route = routes.searchGenres.replace(/:search/, search);
			const data = await this.fetch({ route });

			this.searchResults = data;
		} catch (err) {

			console.log('[FETCH GENRES ERROR]', err);
			return [];
		}
	}

	@action
	deleteGenre (genre) {
		this.delete(genre);
		toast.success('Genre deleted!');
	}

	getLabel(id) {
		const index = this.getItemIndex({ id });
		const genre = this.genres[index];
		return _.isObject(genre) ? genre.label : '';
	}
}

const genreStore = new GenreStore();
export default genreStore;
